export default __webpack_public_path__ + "static/media/wrongRoute.47995fe9.svg";